import { useEffect, useState } from "react";

/**
 * Subscribe to a CSS media query and re-render when it changes.
 *
 * Used to switch between the two-page book spread (wide / landscape) and the
 * single page (phones / portrait), and to detect reduced-motion preference.
 */
export function useMediaQuery(query: string): boolean {
  const get = () =>
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia(query).matches;

  const [matches, setMatches] = useState<boolean>(get);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange(); // sync in case the query changed between render and effect
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
